var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"con-vs-loading vs-loading-background-undefined vs-loading-color-undefined"},[_c('div',{staticClass:"vs-loading border"},[_c('div',{staticClass:"effect-1 effects"}),_c('div',{staticClass:"effect-2 effects"}),_c('div',{staticClass:"effect-3 effects"}),_c('img',{attrs:{"src":""}})])])
}]

export { render, staticRenderFns }